import React from 'react';
import { Header, Footer } from '../Common';
import CollectionShop from '../../Common/CollectionShop/CollectionShop';

/** CLS-DK public collection-shop listing (/clothing/cls-dk/collection/:collectionSlug). */
const CLSDKCollectionShop = () => (
  <CollectionShop
    brandSlug="clsdk"
    feSlug="cls-dk"
    dataBrand="CLS"
    HeaderComponent={Header}
    FooterComponent={Footer}
    packageDescription="Pakkeløsning"
    loadingText="Indlæser produkter…"
    emptyTitle="Ingen produkter lige nu"
    emptyText="Kollektionen er muligvis ved at blive opdateret. Har du spørgsmål, er vi klar til at hjælpe."
    contactLabel="Kontakt os"
    faqLabel="Se FAQ"
  />
);

export default CLSDKCollectionShop;
